import { styled, Tab, Tabs } from '@mui/material'
import { ReactNode, SyntheticEvent } from 'react'

interface StyledTabsProps {
  children?: ReactNode
  onChange: (event: SyntheticEvent, newValue: number) => void
  value: number
  variant?: 'fullWidth' | 'scrollable' | 'standard'
}

interface StyledTabProps {
  label: string
}

interface TabPanelProps {
  children: ReactNode
  index: number
  value: number
}

export const StyledTabList = styled((props: StyledTabsProps) => (
  <Tabs
    {...props}
    TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
  />
))({})

export const StyledTab = styled((props: StyledTabProps) => (
  <Tab disableRipple {...props} />
))(({ theme }) => ({
  fontSize: theme.typography.pxToRem(15),
  fontWeight: theme.typography.fontWeightMedium,
  marginRight: theme.spacing(1),
  textTransform: 'none',
}))

export const TabPanel = (props: TabPanelProps) => {
  const { children, index, value, ...other } = props

  return (
    <div
      aria-labelledby={`simple-tab-${index}`}
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      role="tabpanel"
      {...other}
    >
      {children}
    </div>
  )
}
